import CustomDrawer from "../../../../../../components/CustomDrawer";
import AssignedList from "./AssignedList";
import ShiftInfo from "./ShiftInfo";

type Props = {
  data: string;
  type?: string;
  open: boolean;
  handleClose: (value?: boolean) => void;
};

export default function ShiftDetails({ open, data, handleClose }: Props) {
  return (
    <CustomDrawer
      width={850}
      open={open}
      onClose={handleClose}
      title={"Shift Details"}
    >
      <ShiftInfo shiftId={data} />
      <AssignedList shiftId={data} />
    </CustomDrawer>
  );
}
